export function getImageSrc(imageName: string): string {
  // we want to use the prod assets for storybook because they are not served locally when running storybook
  if (window.location.hostname === 'localhost') {
    return `/assets/${imageName}`;
  }
  return `https://vstatic-prod.apigateway.co/partner-center-client.9223372035099833042.prod/assets/${imageName}`;
}
